import { createSelector } from "reselect";

const usersStateSelector = (state) => state.users;
const selectById = (state, itemId) => itemId;

export const usersSelector = createSelector(
  [usersStateSelector],
  (users) => users.items
);

export const userByIdSelector = createSelector(
  [usersSelector, selectById],
  (users, _id) => {
    const user = users.find((item) => _id === item._id);
    if (!user) return null;
    return user;
  }
);

export const usersAsValueAndLabelSelectors = createSelector(
  [usersSelector],
  users => users.map((user => ({
    _id : user._id,
    firstName : user.firstName,
    lastName : user.lastName,
    email: user.email,
    phone: user.phone
  })))
)  

export const userSettingsSelector = createSelector(
  [usersSelector],
  users => users.map((user => ({
    settingsReceiveNotifications: user.settingsReceiveNotifications,
    settingsDefaultCurrency: user.settingsDefaultCurrency,
    settingsUILanguage: user.settingsUILanguage,
    settingsDefaultCountry: user.settingsDefaultCountry
  })))
)

/**
 * Misc
 */

export const usersIsLoadingSelector = createSelector(
  [usersStateSelector],
  (users) => users.isLoading
);

export const usersCountSelector = createSelector(
  [usersStateSelector],
  (users) => users.count
);

export const searchValueSelector = createSelector(
  [usersStateSelector],
  (users) => users.searchValue
);


export const currentUserSelector = createSelector(
  [usersStateSelector],
  (users) => users.currentUser
)

export const emailExistSelector = createSelector(
  [usersStateSelector],
  (users) => users.emailExist
)